import wixWindow from 'wix-window';
const viewMode = wixWindow.viewMode;

$w.onReady(async function () {
	init();
	const initialData = await $w('#albumsGallery').onReady();
	refreshAlbumData(initialData);
	if (viewMode === "Preview") {
		$w('#albumsGallery').onRefreshHappened((data) => {
			refreshAlbumData(data);
		});
		$w('#albumsGallery').reportPageLoaded();
	}
})

function init() {
	$w('#columnStrip2').hide && $w('#columnStrip2').hide()
	$w('#columnStrip3').hide && $w('#columnStrip3').hide()
	$w('#columnStrip4').hide && $w('#columnStrip4').hide()
	$w('#box16').hide && $w('#box16').hide()
	// $w("#logo").fitMode = "fit";
}

function refreshAlbumData({albumData, sets}) {
	try {
		if (!albumData || !sets) {
			return;
		}
		$w('#textAlbumNameMobile').text = albumData.albumName;
		$w('#dateMobile').text = albumData.albumDate;
		$w('#photographerName').text = albumData.brand.name;
		$w('#textViewAlbum').label = albumData.welcome;
		$w('#textViewAlbum').link = albumData.coverLink;
		$w('#textLinkAlbum').link = albumData.coverLink;
		$w('#coverMobile').items = albumData.coverItemMobile;
		$w('#coverGallery').options = albumData.coverOptions
		$w('#coverGallery').items = albumData.coverItems;
		if (albumData.logoUrl) {
			$w('#logoHtml').show();
			$w("#logoHtml").postMessage(albumData.logoUrl)
		} else {
			$w('#logoHtml').hide();
		}
		if (viewMode !== 'Preview') {
			$w('#logoLinkMobile').link = albumData.motherSiteUrl;
			$w('#logoLink').link = albumData.motherSiteUrl;
		}
	} catch (e) {
		console.error("Error_On_Page", e);
	}
}
